import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { cards } from "@/consts/consts.ts";
let Bank = class Bank extends Vue {
    constructor() {
        super(...arguments);
        // 0: none, 1: 答えが違う, 2: 同一カード
        this.error = 0;
        this.answer = "";
        this.cardsLocal = this.cards;
    }
    addCard(card) {
        if (0 < this.cardsLocal.filter(c => card.name === c.name).length) {
            return 2;
        }
        this.cardsLocal.push(card);
        return -1;
    }
    validateAnswer() {
        let card = cards.DEFAULT;
        if (this.answer === "default") {
            card = cards.DEFAULT;
        }
        else if (this.answer === "りんご") {
            card = cards.BANK;
        }
        else if (this.answer === "かね") {
            card = cards.CASINO;
        }
        else if (this.answer === "すたー") {
            card = cards.HOTEL1;
        }
        else if (this.answer === "はーと") {
            card = cards.HOTEL2;
        }
        else if (this.answer === "おんぷ") {
            card = cards.HOTEL3;
        }
        else if (this.answer === "まさ") {
            card = cards.APART;
        }
        else if (this.answer === "きつつき") {
            card = cards.CASTLE;
        }
        else {
            this.error = 1;
            return;
        }
        this.error = this.addCard(card);
    }
};
__decorate([
    Prop()
], Bank.prototype, "cards", void 0);
__decorate([
    Prop()
], Bank.prototype, "cleared", void 0);
__decorate([
    Prop()
], Bank.prototype, "player", void 0);
Bank = __decorate([
    Component
], Bank);
export default Bank;
